import { Box, Typography } from "@mui/material";
import React from "react";

interface ChartRangeDisplayProps {
  rangeLabel?: string;
  rangeValue: string;
}

/**
 * Reusable chart range display component
 */
const ChartRangeDisplay: React.FC<ChartRangeDisplayProps> = ({
  rangeLabel = "Range",
  rangeValue,
}) => {
  return (
    <Box sx={{ mb: 2 }}>
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ fontSize: "0.75rem" }}
      >
        {rangeLabel}
      </Typography>
      <Typography variant="h6" fontWeight={600} color="text.primary">
        {rangeValue}
      </Typography>
    </Box>
  );
};

export default ChartRangeDisplay;
